import type { BucketNames } from 'clickim/src/common/bucketTypes';

export type { BucketNames };

const FALLBACK_BUCKETS = {
    testResultArtifacts: 'test-result-artifacts',
    projectArtifacts: 'test-projects-artifacts',
    runResultArtifacts: 'run-result-artifacts',
} as const satisfies BucketNames;

let runtimeBuckets: BucketNames | undefined;

/**
 * Override bucket names at runtime (e.g. when received from services clientConfig).
 * Falls back to logical defaults for backward compatibility.
 */
export const setRuntimeBuckets = (buckets: BucketNames): void => {
    runtimeBuckets = buckets;
};

export const getBuckets = (): Readonly<BucketNames> =>
    runtimeBuckets ?? FALLBACK_BUCKETS;
